const t={config:{toolbar:{hidden:[]}},configViewer:{getVideoUrl:o=>`https://video.wixstatic.com/${o.pathname}`}};export{t as DEFAULTS};
//# sourceMappingURL=defaults.js.map
